import { Timestamp } from "firebase-admin/firestore";

export type TutorPaymentSchema = {
    TutorId: string,
    TutorName: string,
    TutorPaymentTier: string,
    sessionDuration48: number,
    sessionTimeStamp: Timestamp,
    ammount: number,
    paid: boolean,
}

const nameofTutorPaymentSchemaCollection = "TutorPayment";
const nameofTutorPaymentSchemaTutorId = "TutorId";
const nameofTutorPaymentSchemaTutorName = "TutorName";
const nameofTutorPaymentSchemaTutorPaymentTier = "TutorPaymentTier";
const nameofTutorPaymentSchemaSessionDuration48 = "sessionDuration48";
const nameofTutorPaymentSchemaSessionTimeStamp = "sessionTimeStamp";
const nameofTutorPaymentSchemaAmmount = "ammount";
const nameofTutorPaymentSchemaPaid = "paid";

export {
    nameofTutorPaymentSchemaCollection,
    nameofTutorPaymentSchemaTutorId,
    nameofTutorPaymentSchemaTutorName,
    nameofTutorPaymentSchemaTutorPaymentTier,
    nameofTutorPaymentSchemaSessionDuration48,
    nameofTutorPaymentSchemaSessionTimeStamp,
    nameofTutorPaymentSchemaAmmount,
    nameofTutorPaymentSchemaPaid
}

export type TutorPaymentView = TutorPaymentSchema & {
    Id: string,
}